<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "pollWrapper"
};
</script>

<style scoped></style>
